import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import HeadSection from "./HeadSection";
import Quienes from "./Quienes";
import Tarifa from "./Tarifa";
import Faqs from "./Faqs";
import Anuncios from "./Anuncios";
import Footer from "./Footer";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { withStyles } from "@mui/styles";

const styles = (theme) => ({
  waButton: {
    position: "fixed",
    display: "none",
    zIndex: "2",
    minHeight: "60px",
    minWidth: "60px",
    bottom: "30px",
    right: "40px",
    color: "white",
    background: "#25d366",
    borderRadius: "30px",
    boxShadow: "1px 6px 24px 0 rgb(7 94 84 / 24%)",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      minHeight: "50px",
      minWidth: "50px",
      borderRadius: "25px",
      display: "flex",
    },
  },
  waImage: {
    fontSize: "3rem !important",
    alignSelf: "center",
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.5rem !important",
    },
  },
});

function Home(props) {
  const {
    selectHome,
    classes,
    addLead,
    errors,
    landing,
    quienes,
    inicio,
    anuncios,
    servicios,
    openTermsDialog,
    pushMessageToSnackbar,
    handleScrollClick,
    idioma,
    messages,
  } = props;

  useEffect(() => {
    selectHome();
  }, [selectHome]);

  return (
    <Fragment>
      <a
        href="https://wa.me/525530743518?text=Hola,%20estoy%20interesado%20en%20conocer%20más%20de%20sus%20soluciones%20en%20comercio%20exterior."
        target="_blank"
        rel="noopener noreferrer"
        className={classes.waButton}
      >
        <WhatsAppIcon className={classes.waImage}></WhatsAppIcon>
      </a>
      <HeadSection
        addLead={addLead}
        errors={errors}
        landing={landing}
        inicio={inicio}
        pushMessageToSnackbar={pushMessageToSnackbar}
        handleScrollClick={handleScrollClick}
        servicios={servicios}
        idioma={idioma}
        messages={messages}
      />

      {/*       <Quienes quienes={quienes} /> */}
      <Tarifa
        servicios={servicios}
        idioma={idioma}
        messages={messages}
        handleScrollClick={handleScrollClick}
        pushMessageToSnackbar={pushMessageToSnackbar}
      />
      <Anuncios errors={errors} inicio={anuncios} messages={messages} />

      <Faqs errors={errors} inicio={quienes} messages={messages} />

      <Footer openTermsDialog={openTermsDialog} messages={messages} />
    </Fragment>
  );
}

Home.propTypes = {
  classes: PropTypes.object,
  selectHome: PropTypes.func.isRequired,
  openTermsDialog: PropTypes.func.isRequired,
  handleScrollClick: PropTypes.func.isRequired,
  addLead: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  landing: PropTypes.object.isRequired,
  quienes: PropTypes.object.isRequired,
  servicios: PropTypes.object.isRequired,
  inicio: PropTypes.object.isRequired,
  faqs: PropTypes.object.isRequired,
  anuncios: PropTypes.object.isRequired,
  width: PropTypes.string,
  theme: PropTypes.object,
  pushMessageToSnackbar: PropTypes.func,
  idioma: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Home);
